__turbopack_context__.v({
  "pagination": "PaginationControls-module-scss-module__9wiKjW__pagination",
  "paginationArrowDisabled": "PaginationControls-module-scss-module__9wiKjW__paginationArrowDisabled",
  "paginationArrows": "PaginationControls-module-scss-module__9wiKjW__paginationArrows",
  "paginationInner": "PaginationControls-module-scss-module__9wiKjW__paginationInner",
  "paginationText": "PaginationControls-module-scss-module__9wiKjW__paginationText",
  "perPageChevron": "PaginationControls-module-scss-module__9wiKjW__perPageChevron",
  "perPageDropdown": "PaginationControls-module-scss-module__9wiKjW__perPageDropdown",
  "perPageLabel": "PaginationControls-module-scss-module__9wiKjW__perPageLabel",
  "perPageMenu": "PaginationControls-module-scss-module__9wiKjW__perPageMenu",
  "perPageOption": "PaginationControls-module-scss-module__9wiKjW__perPageOption",
  "perPageOptionActive": "PaginationControls-module-scss-module__9wiKjW__perPageOptionActive",
  "perPageOptionItem": "PaginationControls-module-scss-module__9wiKjW__perPageOptionItem",
  "perPageSelect": "PaginationControls-module-scss-module__9wiKjW__perPageSelect",
  "perPageSelector": "PaginationControls-module-scss-module__9wiKjW__perPageSelector",
});
